import React from 'react';
import { Modal, Collapsible, CollapsibleItem, Icon } from "react-materialize";
import { withTranslation } from 'react-i18next';
import { compose } from "redux";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import ReactTableBuilder from "../../../utils/reactTableBuilder";


function PoDetails(props) {
  const { t, po, isOpened, onCloseStart, cameraModelsData } = props;

  return (
    <Modal
      open={isOpened}
      header={po.tranName}
      options={{
        onCloseStart: onCloseStart,
      }}
      className="large-modal"
    >
      <TableDetails t={t} po={po} cameraModelsData={cameraModelsData}/>
    </Modal>
  );
}

function TableDetails(props){
  const { t, po, cameraModelsData } = props;

  const columns = [
    {
      Header: t("dashboard_main.camera_model"),
      accessor: "model",
    },
    {
      Header: t("po_detail.creation"),
      accessor: (row) => row.creation_qty ?? 0,
      maxWidth: 100,
    },
    {
      Header: t("po_detail.packed"),
      accessor: (row) => row.packed_qty ?? 0,
      maxWidth: 100,
    },
    {
      Header: t("po_detail.pallet"),
      accessor: (row) => row.pallet_qty ?? 0,
      maxWidth: 100,
    },
    {
      Header: t("po_detail.shipped"),
      accessor: (row) => row.shipped_qty ?? 0,
      maxWidth: 100,
    },
    {
      Header: t("Total"),
      accessor: (row) => {
        return (row.shipped_qty ?? 0) + (row.pallet_qty ?? 0) + (row.packed_qty ?? 0) + (row.creation_qty ?? 0);
      },
      maxWidth: 100,
    },
    {
      Header: t("po_detail.required"),
      accessor: "required_qty",
      getCellProps: () => ({
        className: 'greyed-out-column',
      }),
      maxWidth: 100,
    },
    {
      Header: t("po_detail.reject"),
      accessor: (row) => row.reject_qty ?? 0,
      maxWidth: 100,
    },
    {
      Header: t("po_detail.removed"),
      accessor: (row) => row.removed_qty ?? 0,
      maxWidth: 100,
    },
  ];

  const computedRows = cameraModelsData?.map(cameraModel =>
  {
    const row = cameraModel;
    const poItem = po.items.find(item => item.sku === cameraModel.productCode);
    row.model = cameraModel._id;
    row.required_qty = poItem?.quantity * cameraModel.totalMultiplier;

    return row;
  });

  return <ReactTableBuilder
                columns={columns}
                data={computedRows ?? []}
              />;
}

function getCameraCountForStatus(cameras, status, po) {
  return cameras.filter((camera) => {
    let isOfStatus = false;
    let deleteFoundLookForLastPO = false;
    let foundTestSuccess = false;


    if(camera.qualityControl?.length > 0 && camera.qualityControl[camera.qualityControl.length-1].status === 'FAILED') {
      if(status === 'reject') { //This condition has to remain nested INSIDE the first one.
        isOfStatus = true;
      }
    }
    else {
      for (let index = camera?.footprints.length-1; 0 <= index; index--) {
        const footprint = camera.footprints[index];
  
        if(status === "creation") {
          if(footprint.step === "packaging" || footprint.step === "removed" || footprint.step === "packaging" || footprint.step === "pallet" || footprint.step === "shipping")
            break;
          else if(footprint.step ==="creation") {
            isOfStatus = true;
            break;
          }
        } else if(status === "packaging"){
          if(footprint.step === "creation" || footprint.step === "removed" || footprint.step === "pallet" || footprint.step === "shipping")
            break;
          else if(footprint.step ==="packaging") {
            isOfStatus = true;
            break;
          }
        } else if(status === "removed") {
          if(camera.poNumber !== po.poId) //IF poId don't match it means this camera was returned because at some point it did belong to this PO, so we can safely assume its been removed or deleted at some point.
          {
            isOfStatus = true;
            break;
          } 
        } else if(deleteFoundLookForLastPO && status === "removed" && footprint.step ==="po_changed" && footprint.note === po.poId){
          isOfStatus = true;
          break;
        } else if(status === "pallet"){
          if(footprint.step === "creation" || footprint.step === "removed" || footprint.step === "packaging" || footprint.step === "shipping")
            break;
          else if(footprint.step ==="pallet") {
            isOfStatus = true;
            break;
          }
        } else if(status === "shipped"){
          if(footprint.step === "creation" || footprint.step === "removed" || footprint.step === "packaging" || footprint.step === "pallet")
            break;
          else if(footprint.step ==="shipping") {
            isOfStatus = true;
            break;
          }
        }
      }
    }

    
    return isOfStatus;
  }).length;
}

PoDetails.propTypes = {
    auth: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired
  };
  const mapStateToProps = state => ({
    auth: state.auth,
    errors: state.errors
  });
  
  export default compose(
    withTranslation(),
    connect(
      mapStateToProps,
    )
)(PoDetails);
